import { render } from "./EditComplimentDialog.vue?vue&type=template&id=0c93026c"
import script from "./EditComplimentDialog.vue?vue&type=script&lang=js"
export * from "./EditComplimentDialog.vue?vue&type=script&lang=js"

import "./EditComplimentDialog.vue?vue&type=style&index=0&id=0c93026c&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0c93026c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c93026c', script)) {
    api.reload('0c93026c', script)
  }
  
  module.hot.accept("./EditComplimentDialog.vue?vue&type=template&id=0c93026c", () => {
    api.rerender('0c93026c', render)
  })

}

script.__file = "src/components/EditComplimentDialog.vue"

export default script